// import './css/style.pcss';
import './components';
import './splide';
import './klaro';


const encEmail = 'a29udGFrdEB2aXUteC5kZQ==';
const emails = document.querySelectorAll('.email');
emails.forEach((el) => {
  const inner = el.querySelector('.email-inner');
  const link = document.createElement('a');
  link.setAttribute("href", "mailto:".concat(atob(encEmail)));
  // @ts-ignore
  link.appendChild(inner);
  link.className = el.className;
  el.replaceWith(link);
});
